<template>
  <div class="index">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row>
              <el-col>
                <el-form
                  ref="formData"
                  :model="formData"
                  :rules="rules"
                  label-width="100px"
                  class="demo-ruleForm">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="消息标题" prop="title">
                        <el-input v-model="formData.title"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="所属国家" prop="country">
                        <el-select v-model="formData.country" clearable placeholder="请选择">
                          <el-option
                            v-for="item in ds.country"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="消息类型" prop="notice_type">
                        <el-select v-model="formData.notice_type" clearable placeholder="请选择">
                          <el-option
                            v-for="item in ds.types"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="所属大学">
                        <jm-Search
                          clearable
                          v-model="formData"
                          get-value="school_name"
                          get-type="sh_name_cn"
                          :get-other-value="['school_name', 'school_id']"
                          :getother-type="['sh_name_cn', 'sh_id']"
                          :is-doble="true"
                          :country-id="school_country || 0"
                          get-url='/index/api_base/searchSchool'
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row style="display:none;">
                    <el-col :span="20">
                      <el-form-item label="接收人" prop="receiver">
                        <table v-for="item in ds.group" :key="item.id">
                          <tr>
                            <td valign="top" width="90">
                              <el-checkbox :label="item.id" v-model="formData.receiver">
                                {{ item.name }}
                              </el-checkbox>
                            </td>
                            <td>
                              <p class="small">
                                {{ crewsSpan(item.crews) }}
                              </p>
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="接收人" prop="mini_group">
                        <table v-for="item in ds.mini_group" :key="item.id">
                          <tr>
                            <td valign="top" width="90">
                              <el-checkbox :label="item.id" v-model="formData.mini_group" @change="showGroups(item)">
                                {{ item.name }}
                              </el-checkbox>
                            </td>
                            <td>
                              <p class="small">
                                <el-checkbox-group v-model="formData.mini_users" >
                                  <el-checkbox :label="user.userid" v-for="user in item.users" @change="showUsers(item)" :key="user.userid">
                                    {{ user.truename }}
                                  </el-checkbox>
                                </el-checkbox-group>
                              </p>
                            </td>
                          </tr>
                        </table>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="详细内容" class="ueditor-wrap">
                        <vue-ueditor-wrap v-model="formData.content" :config="editorOption">
                        </vue-ueditor-wrap>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="16">
                      <el-form-item>
                        <el-button :type="formData.sendMessage ? 'primary' : 'success'" @click="submitForm('formData')" style="width:160px">
                          {{ formData.id ? '立即修改' : '立即创建' }}{{ formData.sendMessage ? '并发送' : '' }}
                        </el-button>
                        &nbsp; &nbsp;
                        <el-checkbox :label="1" v-model="formData.sendMessage">
                          同时发消息
                        </el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import { jmSearch } from '@/components/tool';
import VueUeditorWrap from 'vue-ueditor-wrap';
import Lockr from 'lockr';

export default {
  data() {
    return {
      ds: {},
      formData: {
        id: this.$route.params.id || 0,
        title: '',
        country: '',
        school_id: null,
        school_name: '',
        notice_type: '',
        receiver: [],
        content: '',
        sendMessage: false,
        mini_group: [],
        mini_users: [],
      },
      rules: {
        title: [
          { required: true, message: '请输入消息标题', trigger: 'blur' }
        ],
        country: [
          { required: true, message: '请选择所属国家', trigger: 'blur' }
        ],
        notice_type: [
          { required: true, message: '请选择消息类型', trigger: 'blur' }
        ],
        mini_group: [
          { required: true, message: '至少选择一个接收人', trigger: 'blur' }
        ],
      },
      editorOption: {
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: 360, // 初始容器高度
        initialFrameWidth: '99%', // 初始容器宽度
        serverUrl: '/newfib.php/index/ueditor', // 上传文件接口
        UEDITOR_HOME_URL: '/frontend/UEditor/',
        toolbars: [[
          'fullscreen', 'source', '|', 'undo', 'redo', '|',
          'formatmatch', '|', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'blockquote', 'pasteplain', '|',
          'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
          'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
          'directionalityltr', 'directionalityrtl', 'indent', '|',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
          'simpleupload', 'insertimage', 'emotion', 'scrawl', 'insertvideo', 'music', 'attachment', '|',
          'horizontal', 'date', 'time', 'spechars', '|', 'inserttable', 'deletetable', 'charts', '|',
          'searchreplace'
        ]],
        headers: {
          'X-Site-Name': process.env.VUE_APP_SITE_NAME,
          'X-Jwt-Token': Lockr.get('jwt') || '',
        }
      },
    };
  },
  computed: {
    school_country() {
      let cid = this.formData.country;
      let country = this.ds.country.filter((c) => {
        return c.id === cid;
      });

      return country[0] ? country[0].country : '';
    },
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    jmSearch,
    VueUeditorWrap,
  },
  methods: {
    crewsSpan(teachers) {
      let span = [];
      teachers.forEach((item) => {
        if (!item.testkey) {
          span.push(item.truename);
        }
      });

      return span.join('、');
    },
    showGroups(item) {
      let users = item.users.map((user) => {
        return user.userid;
      });
      if (this.formData.mini_group.indexOf(item.id) !== -1) {
        this.addUsers(users);
      } else {
        this.delUsers(users);
      }
      console.log(this.formData.mini_users);
    },
    showUsers(item) {
      // 判断用户是否选择了老师，如果有设置组选中，如果一个都没有设置组不选中
      // 获取本组老师dict
      let users = item.users.map((user) => {
        return user.userid;
      });
      // 判断是否有选的老师
      let flag = false;
      users.forEach((id) => {
        if (this.formData.mini_users.indexOf(id) !== -1) {
          flag = true;
        }
      });
      if (flag) {
        this.addGroup(item.id);
      } else {
        this.delGroup(item.id);
      }
      console.log(flag);
    },
    addUsers(users) {
      // 添加所有本角色用户
      users.forEach((id) => {
        if (this.formData.mini_users.indexOf(id) === -1) {
          this.formData.mini_users.push(id);
        }
      });
    },
    delUsers(users) {
      // 删除所有本角色用户
      for (let i = this.formData.mini_users.length - 1; i >= 0; i--) {
        if (users.indexOf(this.formData.mini_users[i]) !== -1) {
          this.formData.mini_users.splice(i, 1);
        }
      }
    },
    addGroup(gpid) {
      // 添加组id
      if (this.formData.mini_group.indexOf(gpid) === -1) {
        this.formData.mini_group.push(gpid);
      }
    },
    delGroup(gpid) {
      // 删除组id
      if (this.formData.mini_group.indexOf(gpid) !== -1) {
        this.formData.mini_group.splice(this.formData.mini_group.indexOf(gpid), 1);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.formData.id === 'undefined') {
            this.formData.id = 0;
          }

          this.$http._post({
            url: '/index/europe_notice/saveNotice',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              let message = this.formData.id === 0 ? '消息创建' : '消息修改';
              if (this.formData.sendMessage) {
                message += '并发送成功';
              } else {
                message += '成功';
              }
              this.$message({
                type: 'success',
                message: message
              });
              this.$router.push({ name: 'noticeList' });
            }
          });
        } else {
          this.$message.error('带 * 的项目必须填写');
          return false;
        }
      });
    },
    fetchDictData() {
      this.$http
        ._get({
          url: '/index/europe_notice/dictData'
        })
        .then(({ data }) => {
          this.ds = data;
        });
    },
    initFormData() {
      if (this.$route.params.id) { // 修改
        this.$http._get({
          url: '/index/europe_notice/getNotice',
          data: { id: this.$route.params.id }
        }).then((res) => {
          if (res.result === 0) {
            this.formData = res.data;
          }
        }).catch(() => {
          // this.$router.go(-1);
        });
      } else { // 新增
        this.formData.sendMessage = true;
        // this.formData.receiver = ['consultant', 'writing', 'document'];
      }
    }
  },
  mounted() {
    this.initFormData();
    this.fetchDictData();
  },
};
</script>

<style>
  .small {
    font-size: 10px;
    line-height: 160%;
    color: #aaa;
  }
  div.edui-default {
    line-height: 20px;
    box-sizing: content-box;
  }
  input,
  button.edui-default,
  td input.edui-default,
  textarea.edui-default{
    -webkit-appearance: normal !important;
  }
</style>
